import {
  SET_PAGE,
  SET_SEARCH,
  GET_BLOGS,
} from '../../shared/constants/ActionTypes';

const initialexclusiveproperty = {
  blogs: [],
  blogCount: 0,
  page: 1,
  search: '',
};

const blogReducer = (state = initialexclusiveproperty, action) => {
  switch (action.type) {
    case GET_BLOGS:
      return {
        ...state,
        blogs: action.payload.data,
        blogCount: action.payload.total,
      };

    case SET_PAGE:
      return {
        ...state,
        page: action.payload,
      };

    case SET_SEARCH:
      return {
        ...state,
        search: action.payload,
      };

    default:
      return state;
  }
};

export default blogReducer;
